import React from 'react';
import ToggleSelectButton from '../../../global/buttons/ToggleSelectButton';
import { IConditionalOptions } from '../../interfaces/IConditionalLogicPanel';



const ToggleCondition = ({condition} : {condition: IConditionalOptions}) => {
    const { selectedItem, defaultTitle, ariaLabel, className, toggleDisabled, buttonList, label} = condition;

    return (
        <div className="toggle-item">
            {label && <h2 className="toggle-label">{label}</h2>}      
            <ToggleSelectButton
                className={className}
                selectedItem={selectedItem}
                defaultTitle={defaultTitle || ''}
                ariaLabel={ariaLabel}
                buttonList={buttonList}
                toggleDisabled={toggleDisabled}
            />
        </div>
    );
};

export default ToggleCondition